import { Input } from "@/components/ui/input";
import ReactSelect from "react-select";
import BankDocumentsDialog from "./bank_documents_dialog";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  setADRefNo,
  setBankDocument,
  setReason,
} from "redux/features/RefundOrder";
const reasonOptions = [
  {
    value: "Incorrect beneficiary details",
    label: "Incorrect beneficiary details",
  },
  { value: "Beneficiary account closed", label: "Beneficiary account closed" },
  { value: "Payment rejected", label: "Payment rejected" },
  {
    value: "Regulatory or compliance issues",
    label: "Regulatory or compliance issues",
  },
];

export default function Step1() {
  const {
    bank_document,
    sender_name,
    purpose,
    documents,
    AD_ref_no,
    reason,
    extra_document,
  } = useAppSelector((state) => state.CreateRefundOrder);
  const dispatch = useAppDispatch();

  console.log("docs", documents);
  const bank_doc_ids = [50, 51, 52, 53, 29, 45, 46, 47];

  const otherDocumentsList = extra_document?.map((item: any, index: number) => {
    return {
      id: index,
      name: item?.name,
      status: "",
      url: item?.file?.url,
    };
  });

  // const otherDocumentsList = documents
  //   ?.filter((item: any) => !bank_doc_ids.includes(item?.doc_list_id))
  //   .map((item: any) => {
  //     return {
  //       id: item?.doc_list_id,
  //       name: item?.filename,
  //       status: item?.status,
  //       url: item?.file?.url,
  //     };
  //   });

  // otherDocumentsList?.push(...extra_documents);

  const bank_documents = documents
    ?.filter((item: any) => bank_doc_ids.includes(item?.doc_list_id))
    .map((item: any) => {
      return {
        id: item?.doc_list_id,
        name: item?.filename,
        status: item?.status,
        url: item?.file?.url,
      };
    });
  return (
    <div className="flex md:flex-1 flex-col gap-5 md:h-auto items-start justify-start sm:px-0 md:px-5 max-w-[60%] md:w-full">
      <div className="flex sm:pl-0 pl-10 flex-col gap-10 items-start justify-start w-[430px] sm:w-full">
        <div className="flex flex-col relative gap-2.5 items-start justify-center w-full">
          <div
            className={`flex sm:hidden items-center top-0 flex-col after:right-10 after:top-0 after:bottom-0 after:h-24 after:border-blue-700 absolute after:relative after:content-[''] after:border after:border-dashed`}
          >
            <img
              className="relative -left-10"
              src={`images/overview/ellipse.svg`}
              alt=""
            />
          </div>
          <h4 className="text-sm font-medium leading-[17px]">
            Reason for refund
          </h4>
          <ReactSelect
            className="w-full"
            styles={{
              control: (provided, state) => ({
                ...provided,
                zIndex: 0,
                borderRadius: "0.5rem",
                height: "2.5rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderColor: state.isFocused ? "#165FE3" : "#d2d2d2",
                boxShadow: "none",
              }),
            }}
            isSearchable={false}
            isClearable
            value={reasonOptions.find((option) => option.value === reason)}
            options={reasonOptions}
            onChange={(val) => {
              dispatch(setReason(val?.value as string));
            }}
          />
        </div>
        <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
          <div
            className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${true ? "after:h-24 after:border-blue-700" : !true ? "after:h-32 after:border-diabled " : "after:h-28 after:border-blue-700"} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
          >
            <img
              className="relative -left-10 "
              src={`images/overview/ellipse.svg`}
              alt=""
            />
          </div>
          <label
            htmlFor="ad_reference_number"
            className="text-sm font-medium leading-[17px]"
          >
            AD reference number
          </label>
          <Input
            name="ad_reference_number"
            placeholder="Ad reference number"
            className="py-4 px-[15px] placeholder:text-black-900_99 sm:pr-5 text-[15px] text-left w-full"
            type="text"
            id="ad_reference_number"
            value={AD_ref_no}
            onChange={(e) => dispatch(setADRefNo(e.target.value))}
          ></Input>
        </div>
        <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
          <div
            className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${true ? "after:h-24 after:border-blue-700" : !true ? "after:h-32 after:border-diabled " : "after:h-28 after:border-blue-700"} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
          >
            <img
              className="relative -left-10 "
              src={`images/overview/ellipse.svg`}
              alt=""
            />
          </div>
          <label
            htmlFor="purpose"
            className="text-sm font-medium leading-[17px]"
          >
            Purpose
          </label>
          <Input
            disabled
            name="purpose"
            value={purpose}
            id="purpose"
            className="py-4 px-[15px] disabled:border-none disabled:bg-[#FAFAFA] placeholder:text-black-900_99 sm:pr-5 text-[15px] text-left w-full"
            type="text"
          ></Input>
        </div>
        <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
          <div
            className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${true ? "after:h-24 after:border-blue-700" : !true ? "after:h-32 after:border-diabled " : "after:h-28 after:border-blue-700"} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
          >
            <img
              className="relative -left-10 "
              src={`images/overview/ellipse.svg`}
              alt=""
            />
          </div>
          <label
            htmlFor="sender_name"
            className="text-sm font-medium leading-[17px]"
          >
            Sender name
          </label>
          <Input
            disabled
            name="sender_name"
            value={sender_name || "N/A"}
            id="sender_name"
            className="py-4 px-[15px] disabled:border-none disabled:bg-[#FAFAFA] placeholder:text-black-900_99 sm:pr-5 text-[15px] text-left w-full"
            type="text"
          ></Input>
        </div>

        <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
          <div
            className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${true ? "after:h-[400px] after:border-blue-700" : !true ? "after:h-32 after:border-diabled " : "after:h-28 after:border-blue-700"} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
          >
            <img
              className="relative -left-10 "
              src={`images/overview/ellipse.svg`}
              alt=""
            />
          </div>
          <h4 className="text-sm font-medium leading-[17px]">
            Other documents
          </h4>
          {otherDocumentsList?.length !== 0 &&
            otherDocumentsList?.map((item) => {
              return (
                <div
                  key={item?.id}
                  className={`px-4 py-2 justify-between w-full rounded-md items-center flex odd:bg-[#FAFAFA] ${false && "bg-[#F2F7FF]"}`}
                >
                  <div className="flex flex-col overflow-hidden gap-5">
                    <h3 className="text-sm font-normal text-[#333333] leading-[150%]">
                      {item?.name}
                    </h3>
                  </div>
                  <div className="flex items-center gap-5">
                    {true ? (
                      <div className="flex items-center gap-2">
                        <a
                          href={item?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-700 text-sm"
                        >
                          View
                        </a>
                        <svg
                          width="18"
                          height="13"
                          viewBox="0 0 18 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.0642 5.78375C16.2922 6.10325 16.4062 6.26375 16.4062 6.5C16.4062 6.737 16.2922 6.89675 16.0642 7.21625C15.0397 8.65325 12.423 11.75 8.90625 11.75C5.38875 11.75 2.77275 8.6525 1.74825 7.21625C1.52025 6.89675 1.40625 6.73625 1.40625 6.5C1.40625 6.263 1.52025 6.10325 1.74825 5.78375C2.77275 4.34675 5.3895 1.25 8.90625 1.25C12.4237 1.25 15.0397 4.3475 16.0642 5.78375Z"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11.1562 6.5C11.1562 5.90326 10.9192 5.33097 10.4972 4.90901C10.0753 4.48705 9.50299 4.25 8.90625 4.25C8.30951 4.25 7.73722 4.48705 7.31526 4.90901C6.8933 5.33097 6.65625 5.90326 6.65625 6.5C6.65625 7.09674 6.8933 7.66903 7.31526 8.09099C7.73722 8.51295 8.30951 8.75 8.90625 8.75C9.50299 8.75 10.0753 8.51295 10.4972 8.09099C10.9192 7.66903 11.1562 7.09674 11.1562 6.5Z"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    ) : null}
                    <div className="flex items-center gap-2"></div>
                    <input
                      type="file"
                      className="hidden"
                      accept="image/*,application/pdf"
                    />
                  </div>
                </div>
              );
            })}
        </div>
        {bank_documents?.length !== 0 && (
          <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
            <div
              className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${bank_document?.length !== 0 ? "after:h-24 after:border-blue-700" : ""} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
            >
              <img
                className="relative -left-10 "
                src={`images/overview/ellipse.svg`}
                alt=""
              />
            </div>
            <h4 className="text-sm font-medium leading-[17px]">
              Old Bank documents
            </h4>
            {bank_documents?.map((item) => {
              return (
                <div
                  key={item?.id}
                  className={`px-4 py-2 justify-between w-full rounded-md items-center flex odd:bg-[#FAFAFA] ${false && "bg-[#F2F7FF]"}`}
                >
                  <div className="flex flex-col overflow-hidden gap-5">
                    <h3 className="text-sm font-normal text-[#333333] leading-[150%]">
                      {item?.name}
                    </h3>
                  </div>
                  <div className="flex items-center gap-5">
                    {true ? (
                      <div className="flex items-center gap-2">
                        <a
                          href={item?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-700 text-sm"
                        >
                          View
                        </a>
                        <svg
                          width="18"
                          height="13"
                          viewBox="0 0 18 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.0642 5.78375C16.2922 6.10325 16.4062 6.26375 16.4062 6.5C16.4062 6.737 16.2922 6.89675 16.0642 7.21625C15.0397 8.65325 12.423 11.75 8.90625 11.75C5.38875 11.75 2.77275 8.6525 1.74825 7.21625C1.52025 6.89675 1.40625 6.73625 1.40625 6.5C1.40625 6.263 1.52025 6.10325 1.74825 5.78375C2.77275 4.34675 5.3895 1.25 8.90625 1.25C12.4237 1.25 15.0397 4.3475 16.0642 5.78375Z"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11.1562 6.5C11.1562 5.90326 10.9192 5.33097 10.4972 4.90901C10.0753 4.48705 9.50299 4.25 8.90625 4.25C8.30951 4.25 7.73722 4.48705 7.31526 4.90901C6.8933 5.33097 6.65625 5.90326 6.65625 6.5C6.65625 7.09674 6.8933 7.66903 7.31526 8.09099C7.73722 8.51295 8.30951 8.75 8.90625 8.75C9.50299 8.75 10.0753 8.51295 10.4972 8.09099C10.9192 7.66903 11.1562 7.09674 11.1562 6.5Z"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    ) : null}
                    <div className="flex items-center gap-2"></div>
                    <input
                      type="file"
                      className="hidden"
                      accept="image/*,application/pdf"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {bank_document?.length !== 0 && (
          <div className="flex relative flex-col font-inter gap-2.5 items-start justify-start w-full">
            <div
              className={`flex sm:hidden items-center top-0 flex-col after:right-10 ${false ? "after:h-24 after:border-blue-700" : ""} absolute  after:relative  after:content-[''] after:border after:border-dashed `}
            >
              <img
                className="relative -left-10 "
                src={`images/overview/ellipse.svg`}
                alt=""
              />
            </div>
            <h4 className="text-sm font-medium leading-[17px] w-full justify-between items-center flex">
              Updated bank documents
              <button
                className=""
                onClick={() => {
                  dispatch(setBankDocument([]));
                }}
              >
                <svg
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.75705 2.86316L3.44084 14.3562C3.45114 14.5275 3.52641 14.6884 3.65129 14.8061C3.77617 14.9238 3.94125 14.9894 4.11284 14.9895H10.2029C10.3745 14.9894 10.5396 14.9238 10.6645 14.8061C10.7894 14.6884 10.8647 14.5275 10.8749 14.3562L11.5587 2.86316H2.75705ZM12.5718 2.86316L11.8838 14.416C11.8582 14.8445 11.67 15.2471 11.3576 15.5415C11.0452 15.8359 10.6322 15.9999 10.2029 16H4.11284C3.68358 15.9999 3.27055 15.8359 2.95814 15.5415C2.64574 15.2471 2.45754 14.8445 2.432 14.416L1.744 2.86316H0V2.27368C0 2.16201 0.0443609 2.05492 0.123324 1.97596C0.202286 1.89699 0.309382 1.85263 0.421053 1.85263H13.8947C14.0064 1.85263 14.1135 1.89699 14.1925 1.97596C14.2714 2.05492 14.3158 2.16201 14.3158 2.27368V2.86316H12.5718ZM8.8421 0C8.95377 0 9.06087 0.0443609 9.13983 0.123324C9.2188 0.202286 9.26316 0.309383 9.26316 0.421053V1.01053H5.05263V0.421053C5.05263 0.309383 5.09699 0.202286 5.17595 0.123324C5.25492 0.0443609 5.36201 0 5.47368 0H8.8421ZM5.05263 5.05263H6.06316L6.48421 12.6316H5.47368L5.05263 5.05263ZM8.25263 5.05263H9.26316L8.8421 12.6316H7.83158L8.25263 5.05263Z"
                    fill="#FF0000"
                  />
                </svg>
              </button>
            </h4>
            {bank_document?.map((item) => {
              return (
                <div
                  className={`px-4 py-2 justify-between w-full rounded-md items-center flex odd:bg-[#FAFAFA] ${false && "bg-[#F2F7FF]"}`}
                >
                  <div className="flex flex-col overflow-hidden gap-5">
                    <h3 className="text-sm font-normal text-[#333333] leading-[150%]">
                      {item.name}
                    </h3>
                  </div>
                  <div className="flex items-center gap-5">
                    <div className="flex items-center gap-2">
                      <a
                        href={URL.createObjectURL(item?.doc as File)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 text-sm"
                      >
                        View
                      </a>
                      <svg
                        width="18"
                        height="13"
                        viewBox="0 0 18 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.0642 5.78375C16.2922 6.10325 16.4062 6.26375 16.4062 6.5C16.4062 6.737 16.2922 6.89675 16.0642 7.21625C15.0397 8.65325 12.423 11.75 8.90625 11.75C5.38875 11.75 2.77275 8.6525 1.74825 7.21625C1.52025 6.89675 1.40625 6.73625 1.40625 6.5C1.40625 6.263 1.52025 6.10325 1.74825 5.78375C2.77275 4.34675 5.3895 1.25 8.90625 1.25C12.4237 1.25 15.0397 4.3475 16.0642 5.78375Z"
                          stroke="#165FE3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.1562 6.5C11.1562 5.90326 10.9192 5.33097 10.4972 4.90901C10.0753 4.48705 9.50299 4.25 8.90625 4.25C8.30951 4.25 7.73722 4.48705 7.31526 4.90901C6.8933 5.33097 6.65625 5.90326 6.65625 6.5C6.65625 7.09674 6.8933 7.66903 7.31526 8.09099C7.73722 8.51295 8.30951 8.75 8.90625 8.75C9.50299 8.75 10.0753 8.51295 10.4972 8.09099C10.9192 7.66903 11.1562 7.09674 11.1562 6.5Z"
                          stroke="#165FE3"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="flex items-center gap-2"></div>
                    <input
                      type="file"
                      className="hidden"
                      accept="image/*,application/pdf"
                    />
                  </div>
                </div>
              );
            })}
            <p className="flex items-center gap-3 text-sm whitespace-normal w-full mt-5">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346632 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9978 5.87895 15.1542 3.84542 13.6544 2.34562C12.1546 0.845814 10.121 0.00223986 8 0ZM7.69231 3.69231C7.87488 3.69231 8.05334 3.74644 8.20514 3.84787C8.35694 3.9493 8.47526 4.09347 8.54512 4.26214C8.61499 4.43081 8.63327 4.61641 8.59765 4.79547C8.56203 4.97453 8.47412 5.139 8.34502 5.2681C8.21593 5.39719 8.05145 5.48511 7.87239 5.52072C7.69333 5.55634 7.50773 5.53806 7.33906 5.4682C7.17039 5.39833 7.02623 5.28002 6.9248 5.12822C6.82337 4.97642 6.76923 4.79795 6.76923 4.61538C6.76923 4.37057 6.86649 4.13578 7.0396 3.96267C7.21271 3.78956 7.44749 3.69231 7.69231 3.69231ZM8.61539 12.3077C8.28897 12.3077 7.97592 12.178 7.7451 11.9472C7.51429 11.7164 7.38462 11.4033 7.38462 11.0769V8C7.22141 8 7.06488 7.93516 6.94947 7.81976C6.83407 7.70435 6.76923 7.54782 6.76923 7.38461C6.76923 7.2214 6.83407 7.06488 6.94947 6.94947C7.06488 6.83406 7.22141 6.76923 7.38462 6.76923C7.71104 6.76923 8.02409 6.8989 8.2549 7.12971C8.48572 7.36053 8.61539 7.67358 8.61539 8V11.0769C8.7786 11.0769 8.93512 11.1418 9.05053 11.2572C9.16594 11.3726 9.23077 11.5291 9.23077 11.6923C9.23077 11.8555 9.16594 12.012 9.05053 12.1274C8.93512 12.2429 8.7786 12.3077 8.61539 12.3077Z"
                  fill="#C4D7F9"
                />
              </svg>
              Amount will be refunded to the new bank account
            </p>
          </div>
        )}
        {bank_document?.length === 0 && (
          <div className="">
            <h4 className="">Bank account changed ?</h4>
            <BankDocumentsDialog />
          </div>
        )}
      </div>
    </div>
  );
}
